const chains = [];
chains.push({ _operation: 'createSpecialTransferRecord', api: '/special-transfer-record', defaultData: null, httpVerb: 'post' });
chains.push({ _operation: 'removeSpecialTransferRecordById', api: '/special-transfer-record/:objectId/remove', defaultData: null, httpVerb: 'put' });
chains.push({ _operation: 'updateSpecialTransferRecordById', api: '/special-transfer-record/:objectId', defaultData: null, httpVerb: 'patch' });
export default chains;
